import { Component, inject, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DebtorModel, DebtorService } from '@railmybox/api-user';
import { AbstractValueAccessorComponent, ValueAccessorUtil } from '@railmybox/shared/util';
import { catchError, Observable, of, switchMap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'rmb-debtor-select',
  templateUrl: './debtor-select.component.html',
  styleUrl: './debtor-select.component.scss',
  providers: [...ValueAccessorUtil.getValueAccessorProvider(DebtorSelectComponent)],
  standalone: false,
})
export class DebtorSelectComponent extends AbstractValueAccessorComponent<string | DebtorModel> implements OnInit {
  private debtorService = inject(DebtorService);

  debtors$: Observable<DebtorModel[]>;
  searchControl: FormControl = new FormControl<string | null>(undefined);
  selectedName: string;
  @Input() clearable = true;
  @Input() debtorTableDisplay = false;

  ngOnInit(): void {
    this.debtors$ = this.searchControl.valueChanges.pipe(
      untilDestroyed(this),
      switchMap((query: string) => (query ? this.debtorService.adminListDebtors({ query }) : of([])))
    );
  }

  onSearchValueChanged(query: string): void {
    this.searchControl.patchValue(query);
  }

  onSelect(debtor: DebtorModel): void {
    this.selectedName = debtor ? `${debtor.debtorId} - ${debtor.name1}` : null;
    this.value = debtor?.debtorId;

    const value = this.debtorTableDisplay ? debtor : debtor?.debtorId;
    this.onChange(value);
    this.changed.emit(value);
  }

  writeValue(value: string): void {
    super.writeValue(value);

    if (value) {
      this.debtorService
        .adminGetDebtor(value)
        .pipe(
          untilDestroyed(this),

          catchError(() => of(null))
        )
        .subscribe((debtor) => {
          if (debtor) {
            this.value = debtor.debtorId;
            this.selectedName = `${debtor.debtorId} - ${debtor.name1}`;
          } else {
            this.value = undefined;
            this.selectedName = undefined;
          }
        });
    } else {
      this.value = undefined;
      this.selectedName = undefined;
    }
  }
}
